/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogDefault from "@jumbo/components/JumboDialog/components/DialogDefault";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";
import Stack from "@mui/material/Stack";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import Div from "@jumbo/shared/Div";
import Loader from "@jumbo/components/Loader";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import AddVendor from "./add-vendor/index";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { userType } from "app/helpers/userType";
import {
  createVendor,
  deleteVendor,
  getVendorList,
  updateVendor,
} from "app/redux/slice/vendorSlice";
import { getUserList } from "app/redux/slice/userSlice";

const OfficeVendor = () => {
  const { isOpen, onClose, onOpen, stageAction, actionProps } = useDisclosure();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMA } = userType();

  const [searchText, setSearchText] = useState(
    () => localStorage.getItem("vendor-search") || ""
  );
  const [order, setOrder] = useState(
    () => localStorage.getItem("vendor-order") || "desc"
  );
  const [orderBy, setOrderBy] = useState(
    () => localStorage.getItem("vendor-orderBy") || "createdAt"
  );
  const [venderOf, setVenderOf] = useState(
    () => localStorage.getItem("vendor-of") || "All"
  );
  const vendorData = useSelector((state) => state?.vendor);

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "vendor" });
  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );

  const [permission, setPermission] = useState({
    createPermission: false,
    updatePermission: false,
    deletePermission: false,
  });
  const getPermission = () => {
    if (isMA) {
      setPermission({
        createPermission: true,
        updatePermission: true,
        deletePermission: true,
      });
    } else {
      let permissionValue = {
        createPermission: false,
        updatePermission: false,
        deletePermission: false,
      };
      const rolePermission = permissionData;
      rolePermission?.length &&
        rolePermission.forEach(function (num) {
          if (num?.name === "create-vendor") {
            permissionValue.createPermission = true;
          }
          if (num?.name === "delete-vendor") {
            permissionValue.deletePermission = true;
          }
          if (num?.name === "update-vendor") {
            permissionValue.updatePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const columns = [
    { id: "name", label: "Name", sort: true },
    {
      id: "createFor",
      label: "Type",
      render: (row) => row?.createFor?.join(", "),
    },
    { id: "phone", label: "Phone", sort: true },
    { id: "gstNumber", label: "GST NO", sort: true },
    { id: "state", label: "State", sort: true },
    {
      id: "actions",
      label: "Actions",
      minWidth: 140,
      align: "right",
      render: (row) => (
        <>
          {permission.updatePermission && (
            <IconButton
              onClick={() => {
                stageAction(row);
              }}
            >
              <EditIcon />
            </IconButton>
          )}
          {permission.deletePermission && (
            <IconButton
              onClick={() => {
                deleteStageAction(row);
              }}
            >
              <DeleteIcon color={"error"} />
            </IconButton>
          )}
        </>
      ),
    },
  ];

  const handleSubmit = async (data) => {
    const newVendorData = {
      createFor: data?.createFor,
      name: data?.name?.trim(),
      address: data?.address?.trim(),
      phone: data?.phone?.trim(),
      gstNumber: data?.gstNumber?.trim(),
      panNumber: data?.panNumber?.trim(),
      city: data?.city?.trim(),
      state: data?.state?.trim(),
      email: data?.email?.trim(),
      pinCode: data?.pinCode,
    };

    const response = await dispatch(
      actionProps?._id
        ? updateVendor({ id: actionProps._id, data: newVendorData })
        : createVendor(newVendorData)
    ).unwrap();
    if (response.status === 200) {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "success",
      });
      getData();
      onClose();
    } else {
      enqueueSnackbar(response.data?.responseMessage, {
        variant: "error",
      });
    }
  };

  const DeleteVendor = () => {
    dispatch(deleteVendor(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    localStorage.setItem("vendor-search", searchText.trim());
    localStorage.setItem("vendor-of", venderOf);
    localStorage.setItem("vendor-order", order);
    localStorage.setItem("vendor-orderBy", orderBy);
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      ...(venderOf !== "All" && { type: venderOf }),
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getVendorList(value));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
    localStorage.setItem("vendor-order", Order);
    localStorage.setItem("vendor-orderBy", OrderBy);
  };

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  useEffect(() => {
    dispatch(getUserList({ field: "name", sort: 1 }));
  }, []);

  useEffect(() => {
    getPermission();
  }, []);

  return (
    <>
      {vendorData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search Name"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => {
                              setSearchText("");
                              localStorage.removeItem("vendor-search");
                            }}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormControl fullWidth>
                      <InputLabel>Vendor Of</InputLabel>
                      <Select
                        name="vendorOf"
                        id="vendorOf"
                        value={venderOf}
                        label="vendorOf"
                        size="small"
                        onChange={(e) => {
                          const value = e.target.value;
                          setVenderOf(value);
                          localStorage.setItem("vendor-of", value);
                        }}
                      >
                        <MenuItem value={"All"}>{"All"}</MenuItem>
                        {[
                          "Fabric",
                          "Stitch",
                          "Modeling",
                          "Dyer",
                          "ReadyMade",
                        ].map((val) => {
                          return <MenuItem value={val}>{val}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Vendor / Party List
                </Typography>
                {permission.createPermission && (
                  <LoadingButton
                    onClick={() => {
                      onOpen();
                    }}
                    sx={{
                      mt: { xs: 1, md: 0 },
                    }}
                    type="submit"
                    variant="contained"
                  >
                    Add Vendor
                  </LoadingButton>
                )}
              </Stack>
              <Table
                columns={columns}
                rows={vendorData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={vendorData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          <DialogDefault
            open={isOpen}
            onClose={onClose}
            content={
              <AddVendor
                value={actionProps}
                onClose={onClose}
                handleSubmit={handleSubmit}
              />
            }
            title={
              actionProps?._id ? "Update Vendor / Party" : "Add Vendor / Party"
            }
            fullWidth={true}
            maxWidth={"md"}
            actions={<></>}
          />
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the vendor / party?"
            onConfirm={DeleteVendor}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
        </>
      )}
    </>
  );
};

export default OfficeVendor;
